import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=6adaa075&scoped=true"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"
import style0 from "./Environment.vue?vue&type=style&index=0&id=6adaa075&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adaa075",
  null
  
)

export default component.exports